import React, {useState} from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import CreateIcon from "@mui/icons-material/Create";
// import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
// import EmailIcon from "@mui/icons-material/Email";
// import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
// import avtar from "../../../MobileScreens/assets/images/Profile-Picture.jpg";
// import Switch from '@mui/material/Switch';
import CloseIcon from '@mui/icons-material/Close';
// import AttachmentIcon from '@mui/icons-material/Attachment';
import { red } from '@mui/material/colors';
import document from "../../../MobileScreens/assets/images/updated-aadhaar.png";
import Zoom from "react-medium-image-zoom";
import BackupIcon from '@mui/icons-material/Backup';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

function MobileAddListing() {
  const navigate = useNavigate();
  // const label = { inputProps: { 'aria-label': 'Switch demo' } };
  // const [passHideShow, setPassHideShow] = useState(false);
  const [categories, setCategories] = React.useState('');
  
  const handleChangeCategories = (event) => {
        setCategories(event.target.value);
    };
  const [condition, setCondition] = useState('');
  const handleChangeCondition = (event) => {
        setCondition(event.target.value);
    };
  return (
    <>
    <div>
      <div className="drawerFixedPatch"></div>
      <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
          className="backArrowMobil"
          onClick={() => navigate("/MobileMarketPlaceSeller")}
        />
        <h1>Add Listing</h1>
      </div>
    </div>
    <div className="wraperMobile">
      <div className="sectionMobile">
        <div className="famDetailsListMainMob CenterViewBtn">
          <div className="famDetailsListInrMob">
            <div className='FormView'>
              <div className='lebalInputView'>
              <p className='inputLebal'>Title</p>
              <input type='text' placeholder="Title" className='titleInput'/>
              </div>
              <div className='lebalInputView'>
              <p className='inputLebal'>Price</p>
              <input type='text' placeholder="Price" className='titleInput'/>
              </div>
              <div className='lebalInputView'>
              <p className='inputLebal'>Contact No</p>
              <input type='text' placeholder="Contact No" className='titleInput'/>
              </div>
              <div className='lebalInputView'>
              <p className='inputLebal'>Address</p>
              <textarea type='text' placeholder='Address' className='textAreaInput' aria-multiline/>
              </div>
              <div className='lebalInputView'>
                <p className='inputLebal'>Description</p>
                <textarea type='text' placeholder='Description' className='textAreaInput' aria-multiline/>
              </div>
              
              <div className='lebalInputView'>
              <p className='inputLebal'>Categories</p>
              <Select
                value={categories}
                onChange={handleChangeCategories}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                >
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>
                <MenuItem value={'maid'}>Vehicle</MenuItem>
                <MenuItem value={'milk'}>Rentals</MenuItem>
                <MenuItem value={'cook'}>Women's Clothing & Shoes</MenuItem>
                <MenuItem value={'carwash'}>Men's Clothing & Shoes</MenuItem>
                <MenuItem value={'other'}>Furniture</MenuItem>
                <MenuItem value={'other'}>Electronics</MenuItem>
              </Select>
              </div>
              <div className='lebalInputView'>
              <p className='inputLebal'>Condition</p>
              <Select
                value={condition}
                onChange={handleChangeCondition}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                >
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>
                <MenuItem value={'new'}>New</MenuItem>
                <MenuItem value={'used'}>Used</MenuItem>
              </Select>
              </div>
              <div className='attchmentView'>
              <BackupIcon sx={{ fontSize: 30, color: '#3853ec' }} />
              <input type='file' className='fileUploadButton'/>
              <p className='checkBoxTxt'>Document's</p>
              </div>
              <div className="mobDocumentInr">
                <div className="mobDocumentPrev">
                  <Zoom>
                    <img src={document} alt='altimg'/>
                  </Zoom>
                </div>
                  <h1 className="MobUploadedtx">uploaded file</h1>
                  <CloseIcon sx={{ color: red[600], fontSize: 25 }} />
              </div>
              <button className='submitButton' type='submit'>Add Listing</button>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default MobileAddListing